"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
const string_1 = require("../../helpers/string/string");
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Group extends useStore_entities_1.Entity {
    static cache = true;
    static all = () => ({
        api: 'v1',
        method: 'GET',
        route: '/groups',
        wrapper: 'data',
        transform: (response) => response.groups
            .map(({ id, name, abbreviation, description, email, photo_url, created_at, group_type, leaders, parent }) => ({
            id,
            name,
            abbreviation,
            description,
            email,
            photo_url,
            created_at,
            group_type,
            leaders: leaders.map(({ id: leaderId }) => ({ id: leaderId })),
            parent: parent ? { id: parent.id, name: parent.name } : null,
            secondary_people: null,
        })),
    });
    static validate = (item) => 'group_type' in item;
    static details = (attributes) => ({
        api: 'v1',
        method: 'GET',
        route: `/groups/${attributes['id']}`,
        wrapper: 'data',
        transform: (response) => [{
                id: response.group.id,
                secondary_people: response.group.secondary_people,
            }],
    });
    static update = (attributes) => ({
        api: 'v1',
        content: { group: { description: attributes['description'], email: attributes['email'] } },
        method: 'PATCH',
        route: `/groups/${attributes['id']}`,
        wrapper: 'data',
        transform: (response) => [{
                id: response.group.id,
                description: response.group.description,
                email: response.group.email,
            }],
    });
    match = (name) => {
        const matcher = name.toLocaleLowerCase();
        if (this.attributes['abbreviation']) {
            return (0, string_1.cleanStringForSearch)(this.attributes['abbreviation']) === matcher || (0, string_1.cleanStringForSearch)(this.attributes['name']) === matcher;
        }
        return this.attributes['name'].toLocaleLowerCase() === matcher;
    };
}
exports.Group = Group;
//# sourceMappingURL=Group.js.map